<template>
  <div id="bottomLeft">
    <div class="bg-color-black ">
      <div class="d-flex pt-1 pl-2">
        <span style="color:#5cd9e8">
          <icon name="chart-bar"></icon>
        </span>
        <div class="d-flex align-center">
          <span class="fs-xl text mx-2">API 调用量</span>
          <span class="fs-xl text mx-2 ds-balance">DeepSeek 余额 <span :class="dsCls">¥{{dsVal}}</span></span>
        </div>
      </div>
      <div>
        <bottomLeftChart />
      </div>
    </div>
  </div>
</template>

<script>
import bottomLeftChart from "@/components/echart/bottom/bottomLeftChart";
import { firstValue } from "@/api/prom";
export default {
  data() {
    return { dsVal: "--", dsCls: "" };
  },
  components: {
    bottomLeftChart
  },
  mounted() {
    this.refresh();
    this.timer = setInterval(this.refresh, 10000);
  },
  beforeDestroy() {
    clearInterval(this.timer);
  },
  methods: {
    async refresh() {
      const v = await firstValue("deepseek_balance_total");
      if (v == null) return;
      const x = parseFloat(v.toFixed(1));
      this.dsVal = x;
      this.dsCls = x >= 50 ? "ds-ok" : x >= 20 ? "ds-warn" : "ds-bad";
    }
  }
};
</script>

<style lang="scss">
#bottomLeft {
  padding: 1rem;
  height: 130px;
  min-width: 300px;
  border-radius: 5px;
  .bg-color-black {
    height: 117px;
    border-radius: 10px;
  }
  .text {
    color: #c3cbde;
  }
  .ds-ok { color: #33cea0; }
  .ds-warn { color: #facc15; }
  .ds-bad { color: #ff5722; }
}
</style>
